import { Observable, Subject, Subscriber } from 'rxjs';
import { HttpClient } from './http-client';
export class DocumentStorageService extends HttpClient {
  store(
    farmId: string,
    tab: string,
    folderName: string,
    progress: Subscriber<ProgressEvent> | Subject<ProgressEvent>
  ): Observable<any> {
    return this.post(
      `/api/farms/${farmId}/document-storage/${tab}`,
      { folderName },
      {
        onUploadProgress: (event) => {
          if (progress) {
            progress.next(event);
          }
        },
      }
    );
  }

  getFolders(farmId: string, tab: string): Observable<any> {
    return this.get(`/api/farms/${farmId}/document-storage/${tab}`);
  }

  deleteFolder(
    farmId: string,
    tab: string,
    folderName: string
  ): Observable<any> {
    return this.delete(
      `/api/farms/${farmId}/document-storage/${tab}/${folderName}`,
      {
        method: 'DELETE',
      }
    );
  }

  editFolder(
    farmId: string,
    tab: string,
    folderName: string,
    newFolderName: string
  ): Observable<any> {
    return this.put(
      `/api/farms/${farmId}/document-storage/${tab}/${folderName}`,
      { newFolderName }
    );
  }

  uploadFiles(
    farmId: string,
    tab: string,
    folderName: string,
    files: File[]
  ): Observable<any> {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files[]', file);
    });

    return this.post(
      `/api/farms/${farmId}/document-storage/${tab}/${folderName}`,
      formData,
      {
        headers: {
          'Content-Type': null,
        },
      }
    );
  }

  getFiles(farmId: string, tab: string, folderName: string): Observable<any> {
    return this.get(
      `/api/farms/${farmId}/document-storage/${tab}/${folderName}`
    );
  }

  deleteFile(
    farmId: string,
    tab: string,
    folderName: string,
    fileName: string
  ): Observable<any> {
    return this.delete(
      `/api/farms/${farmId}/document-storage/${tab}/${folderName}/${fileName}`,
      {
        method: 'DELETE',
      }
    );
  }

  download(farmId: string, tab: string, folderName: string, fileName: string) {
    return this.get(
      `/api/farms/${farmId}/document-storage/${tab}/${folderName}/${fileName}`,
      {},
      { responseType: 'blob' }
    );
  }

  editFile(
    farmId: string,
    tab: string,
    folderName: string,
    fileName: string,
    newFileName: string
  ): Observable<any> {
    return this.put(
      `/api/farms/${farmId}/document-storage/${tab}/${folderName}/${fileName}`,
      { oldFileName: fileName, newFileName: newFileName }
    );
  }
}
